import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { OnboardingPageComponent } from './modules/onboarding/pages/onboarding-page/onboarding-page.component';
import { AuthorizationResolver } from './resolvers/authorization.resolver';
import { brokerAccessGuard } from './guards/broker-access.guard';

export const routes: Routes = [
  {
    // MsalGuard sits on the parent so it runs to completion (initialize →
    // handleRedirectObservable → account populated) BEFORE brokerAccessGuard.
    // Guards in one canActivate array run concurrently (Router combineLatest),
    // but guards across route levels run sequentially (Router concatMap), so
    // nesting is what guarantees an account exists when brokerAccessGuard reads
    // the roles claim.
    path: '',
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: OnboardingPageComponent,
        canActivate: [brokerAccessGuard],
        resolve: {
          authorization: AuthorizationResolver,
        },
      },
    ],
  },
];
